export default __webpack_public_path__ + "static/media/repituco-logo-disabled.84ddb990.svg";